import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Modal from "components/common/Modal";
import { submitResponse } from "store/approvals/approvalsActions";
import { SWTypes } from "interfaces/sw/SWInterfaces";
import { ApprovalResponseTypes } from "interfaces/approvals/approvalInterfaces";

interface IOutdatedRcApprovalToDraftModal {
  close: any;
  approvalId: number;
  type: SWTypes
}

const OutdatedRcApprovalToDraftModal: React.FC<IOutdatedRcApprovalToDraftModal> = (props) => {
  const dispatch = useDispatch();

  return (
    <Modal
      header="Old versions of Reusable Content found in Standard Work"
      controls={
        <>
          <button
            className="primary-button"
            onClick={() => {
              dispatch(submitResponse({
                approvalRequestId: props.approvalId,
                comment: "",
                responseType: ApprovalResponseTypes.Rejected,
                attachment: null,
                tecConRev: null,
                secondTecConRev: null,
                smeRevUser: null,
                swType: props.type,
                techContetApproval: null,
                techCommApproval: null,
                smeApproval: null,
                moveToDraft: true
              }));
              props.close();
            }}
          >
            Move to Draft
          </button>
          <button
            className="secondary-button"
            onClick={() => {
              props.close();
            }}
          >
            Cancel
          </button>
        </>
      }
      isOpen={true}
    >
      <p>
        The Standard Work uses reusable content that has been updated since this Standard Work was created.
      </p>
      <p>
        This Standard Work will be moved to the Draft State.
      </p>
    </Modal>
  )
}

export default OutdatedRcApprovalToDraftModal;